import { UnSavedWarningMessageContentType } from "@/types/renewals";

import { useFetchMagnoliaModal } from "./use-fetch-magnolia-modal";

const initialData: UnSavedWarningMessageContentType = {
  name: "",
  backButtonLabel: "Go back",
  ctaButtonLabel: "Continue",
  modalTitle:
    "By continuing you will lose all unsaved changes you have made on this page.",
  modalDescription: "",
};

/**
 * Hook for fetching unsaved changes warning modal content from Magnolia CMS
 * Used in renewal flow to warn users about losing unsaved changes
 *
 * @returns { data, loading, error } - Modal content and fetch state
 */
export function useFetchUnsavedChangesWarning() {
  return useFetchMagnoliaModal<UnSavedWarningMessageContentType>(
    "/renewal-unsaved-modal",
    initialData,
    "Failed to fetch unsaved changes warning data"
  );
}
